export default "__VITE_ASSET__Hp4fkhRp__"